import { apiUrl } from '../../../settings'

export const listAllAbstractUrl = () => {
  return apiUrl + '/online-abstract-list'
}

export const addAbstractUrl = () => {
  return apiUrl + '/online-abstract'
}
export const deleteAbstractUrl = () => {
  return apiUrl + '/online-abstract/delete'
}
export const updateAbstractUrl = () => {
  return apiUrl + '/online-abstract/update'
}
export const sendAbstractEmailUrl = () => {
  return apiUrl + '/online-abstract/send-email'
}
export const addAbstractNoteUrl = () => {
  return apiUrl + '/online-abstract/add-note'
}
export const listAbstractNotesUrl = () => {
  return apiUrl + '/online-abstract/notes-list'
}
export const listAbstractActivityUrl = () => {
  return apiUrl + '/online-abstract/activity-list'
}
export const selectAbstractEmailUrl = (id) => {
  return apiUrl + `/online-abstract/email/${id}`
}
